/* eslint-disable no-lonely-if */
/* global femcare */
/* eslint-disable id-length */

femcare.shared.util = {
    baseUrl: $('body').attr('data-base-url'),
    $modal: $('#modal'),
    focusableSelectors: 'a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, embed, [tabindex]:not([tabindex="-1"])',

    mediaqueries: {
        extraSmall: 1,
        small: 2,
        medium: 3,
        large: 4,
        largeNav: 5,
        extraLarge: 6
    },

    eventKeyCodes: {
      enter: 13,
      escape: 27,
      tab: 9
    },

    // $screen-lg-navbar
    richNavbarScreenMinWidth: 1280,
  
    getMediaqueryState: function() {
        var indicatorEl = document.querySelector('.mediaquery-state-indicator');
        var mediaqueryIndicator = window.getComputedStyle(indicatorEl, ':before').getPropertyValue('content');

        return parseInt(mediaqueryIndicator.replace(/^"(.*)"$/, '$1'), 10);
    },

    // Check if browser or screen width satisfies rich navbar threshold.
    isRichNavbarActive: function() {
        return (
            window.innerWidth >= this.richNavbarScreenMinWidth ||
            screen.width >= this.richNavbarScreenMinWidth
        );
    },

    // Durstenfeld algorithm for array shuffle
    shuffleArray: function(array) {
        for (var i = array.length - 1; i > 0; i--) {
            var j = Math.floor(Math.random() * (i + 1));
            var temp = array[i];
            array[i] = array[j];
            array[j] = temp;
        }
    },

    // Checks if DOM element is within viewport
    // https://stackoverflow.com/questions/123999/how-to-tell-if-a-dom-element-is-visible-in-the-current-viewport
    isElementInViewport: function(el) {
        if (typeof jQuery === 'function' && el instanceof jQuery) {
            el = el[0];
        }

        var rect = el.getBoundingClientRect();

        return (
            rect.top >= 0 &&
            rect.left >= 0 &&
            rect.bottom <=
                (window.innerHeight ||
                    document.documentElement.clientHeight) /* or $(window).height() */ &&
            rect.right <=
                (window.innerWidth ||
                    document.documentElement.clientWidth) /* or $(window).width() */
        );
    },

    // Verifies that right-to-left layout is active
    isRTLContext: function () {
        return $('body').hasClass('rtl');
    },

    // Get frontend assets path
    getAssetsPath: function () {
        var assetsPath = $('[data-static-directory]').data('static-directory') || '';
        if (assetsPath.substring(assetsPath.length - 1) === '/') {
            assetsPath = assetsPath.substring(0, assetsPath.length - 1);
        }

        return assetsPath;
    },

    /**
     * Adds debounce functionality.
     */
    debounce: function (func, wait) {
        var timeout;

        return function () {
            clearTimeout(timeout);
            timeout = setTimeout(func, wait);
        };
    },

    // Checks if any part of a DOM element is within viewport
    isAnyPartOfElementInViewport: function (el) {
        if (typeof jQuery === 'function' && el instanceof jQuery) {
            el = el[0];
        }

        var rect = el.getBoundingClientRect();

        return (
            rect.bottom > 0 &&
            rect.right > 0 &&
            rect.top < (window.innerHeight || document.documentElement.clientHeight) &&
            rect.left < (window.innerWidth || document.documentElement.clientWidth)
        );
    },

    /**
    * Extracts the domain from a URL.
    * @param {string} url - The URL to extract the domain from.
    * @returns {string} The extracted domain.
    */
   extractDomain: function (url) {
       var domain;
       if (url.indexOf('://') > -1) {
           domain = url.split('/')[2];
       } else {
           domain = url.split('/')[0];
       }
       domain = domain.split(':')[0];
       domain = domain.replace('www.', '');

       return domain;
   },

   /**
    * Gets the current domain of the website.
    * @returns {string} The current domain.
    */
   getCurrentDomain: function () {
       var currentURL = window.location.href;

       return this.extractDomain(currentURL);
   },

    /*
     * Gets the current enrty for the provided property value.
     * @returns {object} The object with tehe GA data.
     */
       getEntryFromObject: function (source, name, value) {
        var result = source.filter(function(entry) {

            return entry[name].toString() === value.toString();
        });

        return result;
    },

    /**
     * Converts a relative URL to an absolute URL.
     * @param {string} relativeUrl - The relative URL.
     * @returns {string} Absolute URL.
     */
    getFullUrl: function (relativeUrl) {
        const tempAnchor = document.createElement('a');
        tempAnchor.href = relativeUrl;

        return tempAnchor.href;
    },

    /**
     * Update the submit button state based on form validation and consent.
     * @param {jQuery} $form - The jQuery object representing the form.
     */
    updateFormButtonState: function($form) {
        const $submitButton = $form.find('button[type="submit"]');
        const hasConsentFields = $form.find('.consentCheckbox').length > 0;
        const allElementsValid = !$form.find('.form-group.has-error').length;
        const consentGiven = hasConsentFields ? $form.find('.consentCheckbox:checked').length > 0 : true;

        $submitButton.prop('disabled', !(allElementsValid && consentGiven));
    },

    /**
     * Shows only the correct app download button based on device (Android/iOS).
     */
    toggleStoreButtonsByDevice: function () {
        const isAndroid = /Android/i.test(navigator.userAgent);
        const isIOS = /iPhone|iPad|iPod/i.test(navigator.userAgent);

        const androidBtn = document.querySelector('.hero-slide__download-android');
        const iosBtn = document.querySelector('.hero-slide__download-ios');

        if (isAndroid && iosBtn) {
            iosBtn.classList.add('hidden');
        } else if (isIOS && androidBtn) {
            androidBtn.classList.add('hidden');
        }
    },
};
